import { IFormService } from "../../service/form/FormService";

export default class UploadSignedReportInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(formVersionId: number, document: File) {
    return this.formService.uploadSignedReport(formVersionId, document);
  }
}
